import React from "react";

export default () => (
  <section id="flow">
    <div className="section_title">
      <p>FLOW</p>
      <h2>WEB制作の業務範囲と流れ</h2>
    </div>
    <div className="section_contents">
      <div className="flow_text">
        <p>
          Webディレクター、<br />デザイナーからエンジニアまで、<br />すべてを社内で一貫して<br />スムーズな制作を行っています。
        </p>
      </div>
      <div className="flow_list clearfix">
        <div className="flow_first">
          <div className="flow_start">
            <p>製作開始</p>
          </div>
          <div className="flow_numbers">
            <div className="item">
              <div className="itemwrapper">
                <p className="num">01</p>
                <p className="title">
                  要件定義<br />ヒアリング
                </p>
                <div className="job">
                  <p>企画提案営業</p>
                  <p>Webディレクター</p>
                </div>
              </div>
            </div>
            <div className="item">
              <div className="itemwrapper">
                <p className="num">02</p>
                <p className="title">
                  分析・調査<br />情報設計
                </p>
                <div className="job">
                  <p>Webディレクター</p>
                  <p />
                </div>
              </div>
            </div>
            <div className="item">
              <div className="itemwrapper">
                <p className="num">03</p>
                <p className="title">
                  デザイン<br />
                </p>
                <div className="job">
                  <p>Webデザイナー</p>
                  <p />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="flow_second">
          <div className="flow_numbers">
            <div className="item">
              <div className="itemwrapper">
                <p className="num">04</p>
                <p className="title">
                  コーディング<br />
                </p>
                <div className="job">
                  <p>Webデザイナー</p>
                  <p className="small">フロントエンドエンジニア</p>
                </div>
              </div>
            </div>
            <div className="item">
              <div className="itemwrapper">
                <p className="num">05</p>
                <p className="title">
                  CMS設計<br />構築
                </p>
                <div className="job">
                  <p className="small">フロントエンドエンジニア</p>
                  <p>Webエンジニア</p>
                </div>
              </div>
            </div>
            <div className="item">
              <div className="itemwrapper">
                <p className="num">06</p>
                <p className="title">
                  テスト<br />検証
                </p>
                <div className="job">
                  <p className="small">フロントエンドエンジニア</p>
                  <p>Webエンジニア</p>
                </div>
              </div>
            </div>
            <div className="item">
              <div className="itemwrapper">
                <p className="num">07</p>
                <p className="title">
                  本番<br />リリース
                </p>
                <div className="job">
                  <p className="small">フロントエンドエンジニア</p>
                  <p>Webエンジニア</p>
                </div>
              </div>
            </div>
          </div>
          <div className="flow_end">
            <p>管理運用へ</p>
          </div>
        </div>
      </div>
    </div>
  </section>
)



// WEBPACK FOOTER //
// ./src/Home/Flow.js